// Problematic Orders table (manager/admin) — extracted verbatim from StatisticsPage.tsx.
import React from 'react';
import { ProblematicOrder } from './shared';

export default function ProblematicTable({ problematic }: { problematic: ProblematicOrder[] }) {
  return (
    <div className="bg-[#1a1d27] rounded-xl border border-gray-800">
      <div className="px-4 py-3 border-b border-gray-800">
        <h2 className="text-sm font-semibold text-white">Problematic Orders</h2>
        <p className="text-xs text-gray-600 mt-0.5">Orders moved to cant_find, label_issue, or hard_to_find</p>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-gray-500 text-xs border-b border-gray-800">
              <th className="px-4 py-2 text-left font-medium">Order #</th>
              <th className="px-4 py-2 text-left font-medium">Customer</th>
              <th className="px-4 py-2 text-left font-medium">Problem</th>
              <th className="px-4 py-2 text-left font-medium">By</th>
              <th className="px-4 py-2 text-left font-medium">When</th>
              <th className="px-4 py-2 text-left font-medium">Current tab</th>
            </tr>
          </thead>
          <tbody>
            {problematic.map((p, i) => (
              <tr key={i} className="border-b border-gray-800/50 hover:bg-gray-800/20 transition-colors">
                <td className="px-4 py-2.5 text-blue-400 font-medium">#{p.external_id}</td>
                <td className="px-4 py-2.5 text-gray-200">{p.customer_name}</td>
                <td className="px-4 py-2.5">
                  <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${
                    p.problem_tab === 'cant_find'   ? 'bg-red-900/60 text-red-300' :
                    p.problem_tab === 'label_issue' ? 'bg-orange-900/60 text-orange-300' :
                                                      'bg-yellow-900/60 text-yellow-300'
                  }`}>
                    {p.problem_tab.replace(/_/g, ' ')}
                  </span>
                </td>
                <td className="px-4 py-2.5 text-gray-400">{p.display_name}</td>
                <td className="px-4 py-2.5 text-gray-500 text-xs whitespace-nowrap">
                  {p.moved_at ? new Date(p.moved_at).toLocaleString('et-EE', { dateStyle: 'short', timeStyle: 'short' }) : '—'}
                </td>
                <td className="px-4 py-2.5 text-gray-500 text-xs">{p.tab}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
